import { ReactComponent as CoinsBambooLogoMedium } from "./logo-medium.svg";

const LogoMedium: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
> = (props) => <CoinsBambooLogoMedium {...props} />;

export default LogoMedium;
